export const truncateMiddle = (text: string, startChars: number, endChars: number, maxLength: number) => {
  if (text.length > maxLength) {
    const start = text.substring(0, startChars);
    const end = text.substring(text.length - endChars, text.length);
    return `${start}...${end}`;
  }
  return text;
};
